module.exports = __webpack_public_path__ + "media/1.add17652.wav";